// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

function sanitize(urlString, base) {
  if (!urlString) {
    return null;
  }
  const url = new URL(urlString, base);
  if (!["http:", "https:"].includes(url.protocol)) {
    return null;
  }
  return url.toString();
}

const href = {
  sanitize,
};
export default href;
